/* eslint-disable react/prefer-stateless-function */
/* eslint-disable max-classes-per-file */
import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import Tabs from '../../components/@base/Tabs';
import DialogNotification from '../../components/DialogNotification/DialogNotification';
import DetailsConfigurations from '../../components/WatsonComponents/Configurations/DetailsConfigurations';
import Entities from '../../components/WatsonComponents/Entities/Entities';
import Intents from '../../components/WatsonComponents/Itents/Intents';
import ContextBots from '../../context/FlowContext';
import ContextWatson from '../../context/WatsonContext';
import ComponentConfigurationBreadCrumbs from '../ComponentConfigurations/ComponentConfigurationsBreadCrumbs';
import ComponentConfigurationHelpButton from '../ComponentConfigurations/ComponentConfigurationsHelpButton';
import style from './WatsonConfigurations.module.css';

class WatsonConfigurations extends Component {
  constructor() {
    super();
    this.state = {
      component: {},
      activedTab: 0,
      showHelperDialog: false,
    };

    this.setState = this.setState.bind(this);
  }

  componentDidMount() {
    this.props.setWidth('m5');
    this.props.setScroll(false);
    this.props.setWithBackdrop(false);
    if (this.props.flowContext.flow) {
      this.preparingState();
    }
  }

  componentDidUpdate() {
    const { componentSelected } = this.props;
    if (componentSelected) {
      this.props.setBoxOpened(true);
    } else {
      this.props.setBoxOpened(false);
    }
  }

  preparingState = () => {
    this.props.setBoxOpened(true);

    const { componentSelected } = this.props;
    const { flow } = this.props.flowContext;
    const environmentConfigurations = flow.environment;

    let description = '';
    let engineRelease = '';
    let parameters = [];

    for (const el of flow.stack.supportedEngineReleases) {
      if (componentSelected.typeElement.title === el.engine.name) {
        description = el.engine.description;
        engineRelease = el.id;
        parameters = componentSelected.parameters
          ? componentSelected.parameters
          : el.parameters.map((p) => ({ parameter: p, value: p.defaultValue || '' }));
        break;
      }
    }

    this.setState({
      component: {
        ...componentSelected,
        description,
        engineRelease,
        environmentConfigurations,
        parameters,
      },
    });
  }

  composeTabs = () => {
    const tabs = [
      {
        title: 'Configurações',
        content: <DetailsConfigurations
          componentsListNames={this.props.componentsListNames}
          component={this.state.component}
          updateWatsonComponent={this.props.updateWatsonComponent}
        />,
      },
    ];

    if (this.props.watsonContext.entities || this.props.watsonContext.intents) {
      tabs.splice(0, 0, {
        title: 'Entidades',
        content: <Entities entities={this.props.watsonContext.entities} />,
      });

      tabs.splice(0, 0, {
        title: 'Intenções',
        content: <Intents intents={this.props.watsonContext.intents} />,
      });
    }

    return tabs;
  }

    /** Mostra uma caixa de dialogo que explica como funciona o componente */
    showHelperDialogComponent = () => {
      if (this.state.showHelperDialog) {
        const content = (
          <div className={style.Helper}>
            {ReactHtmlParser(this.state.component.description)}
          </div>
        );
        return (
          <DialogNotification
            color="info"
            title={<p>Como funciona esse componente?</p>}
            content={content}
            okAction={() => this.setState({ showHelperDialog: false })}
          />
        );
      }
    }

    render() {
      return (
        <>
          {this.showHelperDialogComponent()}
          <div className={style.Header}>
            <ComponentConfigurationBreadCrumbs
              title={this.props.componentSelected.typeElement.title}
              label={this.props.componentSelected.label}
            />
            <ComponentConfigurationHelpButton
              setState={this.setState}
            />
            <div className="clearfix" />
          </div>

          <Tabs
            classes={`tabs ${style.Tabs}`}
            activedTab={this.state.activedTab}
            contentStyle={style.ContentConfigurations}
            tabs={this.composeTabs()}
          />
        </>
      );
    }
}

class WatsonConfigurationsWraper extends Component {
  render() {
    return (
      <ContextBots.Consumer>
        { (flowContext) => (
          <ContextWatson.Consumer>
            { (watsonContext) => (
              <WatsonConfigurations
                flowContext={flowContext}
                watsonContext={watsonContext}
                {...this.props}
              />
            )}
          </ContextWatson.Consumer>
        )}
      </ContextBots.Consumer>
    );
  }
}

export default WatsonConfigurationsWraper;
